import { getBasePath } from '~/api/experiments/base';

export function buildCollectFromExecutionPath(
  realm: string,
  pipelineName: string,
  pipelineVersion: number,
  connectorId: string,
  datasetId: string
): string {
  return `${getBasePath(realm, pipelineName, pipelineVersion, connectorId)}/datasets/${encodeURIComponent(datasetId)}/collect-from-execution`;
}
